<template>
  <div class="account main">
    <div class="mt20">
      <span class="title1">下载中心</span>
    </div>
    <div class="mt20 overflow-h">
      <!-- <span class="fr purple-btn" @click="newAccount" style="position: relative;z-index: 1000;">新建客户</span> -->
    </div>
    <div class="search-one">
      <div class="search-item">
        文件名称
        <Input class='ml10 mr20 w200' v-model="screenData.user_name" placeholder="请输入姓名" />
        下载日期
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
        <button class="ivu-btn ivu-btn-primary fr" @click="setPage(1)">搜索</button>
      </div>
    </div>
    <section class="account-box mt20">
      <Table border :columns="columns" :data="list">
        <template slot-scope="{ row, index }" slot="notice">
          <i-switch v-model="row.is_need_notice" @on-change="change(row)"></i-switch>
        </template>
      </Table>
      <Paging v-bind:page-data="pageData" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
    </section>
  </div>
</template>
<script>
  import Paging from "@/components/common/paging";
  export default {
    components: {
      Paging
    },
    data() {
      return {
        pageData: {
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 11 //页面最多显示几个分页组
        },
        screenData: {
          PageNum: 1,
          PageSize: 10
        },
        columns: [{
            title: "文件名称",
            key: "file_name",
            tooltip: true,
            minwidth: 100,
          }, {
            title: "来自业务",
            key: "from_type",
            tooltip: true,
            width: 140,
          },
          {
            title: "下载时间",
            key: "create_date",
            width: 180,
          },
          {
            title: "生成进度",
            key: "generate_progress",
            width: 120,
             render: (h, params) => {
               return h("div", params.row.generate_progress + " %");
             }
          },
          {
            title: "生成时间",
            key: "finished_date",
            width: 180,
          }, {
            title: '操作',
            width: 200,
            fixed: 'right',
            render: (h, params) => {
              let doms = [];
              if (params.row.finished_date) {
                doms.push(h('span', {
                  style: {
                    cursor: "pointer",
                    color: "#0062da"
                  },
                  on: {
                    click: () => {

                      this.downloadFile(params.row.file_path);

                    }
                  }
                }, '下载文件'));
              }

              return h("div", doms);
            }
          }
        ],
        list: []
      };
    },
    methods: {

      sDateChange(e) {
        if (e) {
          this.screenData.create_start_date = e + ' 00:00:00'
        } else {
          this.screenData.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screenData.create_end_date = e + ' 23:59:59'
        } else {
          this.screenData.create_end_date = ''
        }
      },
      setPage(page) {
        this.pageData.pageIndex = page;
        this.screenData.PageNum = page;
        this.getList();
      },
      chooseSize(size) {
        this.pageData.pageSize = this.screenData.PageSize = size;
        let p = Math.ceil(this.pageData.dataTotal / this.pageData.pageSize);
        if (this.pageData.pageIndex > p) {
          this.pageData.pageIndex = this.screenData.PageNum = p;
        }
        this.getList();
      },
      getList() {
        this.$axios.get("/download/list", {
          params: this.screenData
        }).then(res => {
          let arr = [];
          if (res.success && res.data && res.data.length > 0) {
            arr = res.data;
          }
          this.list = arr;
          this.pageData.pageTotal = res.pageTotal;
          this.pageData.dataTotal = res.totalSize;
        });
      },
      //删除
      downloadFile(file_path) {

        let a = document.createElement('a'); //创建一个<a></a>标签
        a.href = file_path; //赋值url
        a.download = file_path; //文件名称
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click(); //点击下载
        a.remove(); //删除标签
        this.$Message.info('下载成功');

      }
    },
    created() {
      this.screenData.warehouse_id = localStorage.getItem('warehouse_id');

      this.getList();
    }
  };
</script>
<style lang="scss">
  .new-account {
    .label {
      display: inline-block;
      width: 100px;
      text-align: right;
      margin-right: 10px;
    }

    .list {
      height: 50px;
      line-height: 50px;
      // margin-bottom: 5px;
    }
  }

  .account {
    .account-box {
      margin: 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/download/list.vue